import type React from 'react'
import { twMerge } from 'tailwind-merge'

interface SkeletonBlockProps {
  className?: string
}

export const SkeletonBlock: React.FC<SkeletonBlockProps> = ({ className = '' }) => (
  <div
    aria-hidden="true"
    className={twMerge(
      'rounded bg-gray-200 motion-safe:animate-pulse motion-reduce:animate-none',
      className
    )}
  />
)
